type Props = {
  collapsed?: boolean;
};

export default function PayrollIcon({ collapsed }: Props) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0001 9.94495L19.0001 0.944946M16.3641 3.58099C14.7698 1.98987 12.6364 1.05509 10.386 0.961569C8.13551 0.868048 5.93192 1.6226 4.21115 3.07595C2.49037 4.5293 1.37776 6.57558 1.09343 8.80996C0.809105 11.0443 1.37377 13.304 2.67571 15.142C3.97765 16.98 5.92203 18.2624 8.12419 18.7355C10.3263 19.2086 12.6258 18.8379 14.5678 17.6968C16.5097 16.5557 17.9526 14.7272 18.611 12.5732C19.2695 10.4192 19.0954 8.09652 18.1234 6.06468M13.1821 6.76296C12.4381 6.01903 11.457 5.5593 10.4092 5.46368C9.36148 5.36805 8.31335 5.64258 7.447 6.23955C6.58065 6.83651 5.95087 7.71817 5.66711 8.73129C5.38334 9.74441 5.46355 10.8249 5.89378 11.785C6.324 12.7452 7.07705 13.5242 8.02204 13.9867C8.96703 14.4492 10.0442 14.566 11.0664 14.3167C12.0885 14.0675 12.991 13.4679 13.617 12.6223C14.243 11.7767 14.5529 10.7384 14.4928 9.68805"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
